import React from 'react'
import * as S from './styles'
import { Link, useHistory, useLocation } from 'react-router-dom'
import useStore from '../../hooks/useStore'

type MenuProps = {
  type: 'Admin' | 'Store'
}

const Menu: React.FC<MenuProps> = ({ type }) => {
  const store = useStore()
  const { pathname } = useLocation()
  const history = useHistory()
  const logout = () => {
    localStorage.removeItem('app-token')
    localStorage.removeItem('user')

    history.push('/login')
  }

  return (
    <S.MenuWrapper>
      <S.List>
        {type === 'Store' && (
          <>
            <S.ListItem
              isActive={
                pathname.includes('store') && !pathname.includes('type')
              }
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="17"
                viewBox="0 0 16 17"
                fill="none"
              >
                <g clipPath="url(#clip0_129_1237)">
                  <path
                    d="M2 6.50004L8 1.83337L14 6.50004V13.8334C14 14.187 13.8595 14.5261 13.6095 14.7762C13.3594 15.0262 13.0203 15.1667 12.6667 15.1667H3.33333C2.97971 15.1667 2.64057 15.0262 2.39052 14.7762C2.14048 14.5261 2 14.187 2 13.8334V6.50004Z"
                    stroke="#99800C"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M6 15.1667V8.5H10V15.1667"
                    stroke="#99800C"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_129_1237">
                    <rect
                      width="16"
                      height="16"
                      fill="white"
                      transform="translate(0 0.5)"
                    />
                  </clipPath>
                </defs>
              </svg>
              <Link to={`/store/${store?.id}`}>Início</Link>
            </S.ListItem>
            <S.ListItem isActive={pathname.includes('type')}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="17"
                viewBox="0 0 16 17"
                fill="none"
              >
                <g clipPath="url(#clip0_129_1242)">
                  <path
                    d="M13.3333 8.5V15.1667H2.66667V8.5"
                    stroke="#313131"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M14.6667 5.16663H1.33333V8.49996H14.6667V5.16663Z"
                    stroke="#313131"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M8 15.1666V5.16663"
                    stroke="#313131"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M8 5.16671H11C11.442 5.16671 11.866 4.99111 12.1785 4.67855C12.4911 4.36599 12.6667 3.94207 12.6667 3.50004C12.6667 3.05801 12.4911 2.63409 12.1785 2.32153C11.866 2.00897 11.442 1.83337 11 1.83337C8.66667 1.83337 8 5.16671 8 5.16671Z"
                    stroke="#313131"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M8 5.16671H5C4.55797 5.16671 4.13405 4.99111 3.82149 4.67855C3.50893 4.36599 3.33333 3.94207 3.33333 3.50004C3.33333 3.05801 3.50893 2.63409 3.82149 2.32153C4.13405 2.00897 4.55797 1.83337 5 1.83337C7.33333 1.83337 8 5.16671 8 5.16671Z"
                    stroke="#313131"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_129_1242">
                    <rect
                      width="16"
                      height="16"
                      fill="white"
                      transform="translate(0 0.5)"
                    />
                  </clipPath>
                </defs>
              </svg>
              <Link to={`/store/${store?.id}/types`}>Tipos de lista</Link>
            </S.ListItem>
            <S.ListItem isActive={pathname.includes('configuration')}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="17"
                viewBox="0 0 16 17"
                fill="none"
              >
                <g clipPath="url(#clip0_129_1250)">
                  <path
                    d="M8 10.5C9.10457 10.5 10 9.60457 10 8.5C10 7.39543 9.10457 6.5 8 6.5C6.89543 6.5 6 7.39543 6 8.5C6 9.60457 6.89543 10.5 8 10.5Z"
                    stroke="#313131"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M12.9333 10.5C12.8446 10.701 12.8181 10.9241 12.8573 11.1404C12.8965 11.3566 12.9996 11.5562 13.1533 11.7133L13.1933 11.7533C13.3173 11.8771 13.4156 12.0242 13.4827 12.186C13.5498 12.3479 13.5844 12.5214 13.5844 12.6966C13.5844 12.8718 13.5498 13.0453 13.4827 13.2072C13.4156 13.3691 13.3173 13.5161 13.1933 13.64C13.0695 13.7639 12.9225 13.8623 12.7606 13.9294C12.5987 13.9965 12.4252 14.031 12.25 14.031C12.0748 14.031 11.9013 13.9965 11.7394 13.9294C11.5775 13.8623 11.4305 13.7639 11.3067 13.64L11.2667 13.6C11.1095 13.4463 10.91 13.3432 10.6937 13.304C10.4775 13.2647 10.2544 13.2912 10.0533 13.38C9.85615 13.4645 9.68799 13.6048 9.56954 13.7836C9.45109 13.9625 9.38752 14.1721 9.38667 14.3866V14.5C9.38667 14.8536 9.24619 15.1927 8.99614 15.4428C8.74609 15.6928 8.40695 15.8333 8.05333 15.8333C7.69971 15.8333 7.36057 15.6928 7.11052 15.4428C6.86048 15.1927 6.72 14.8536 6.72 14.5V14.44C6.71484 14.2193 6.64341 14.0053 6.51501 13.8258C6.3866 13.6462 6.20716 13.5095 6 13.4333C5.79892 13.3445 5.57587 13.3181 5.35961 13.3573C5.14334 13.3965 4.94379 13.4996 4.78667 13.6533L4.74667 13.6933C4.62284 13.8173 4.47578 13.9156 4.31392 13.9827C4.15206 14.0498 3.97855 14.0843 3.80333 14.0843C3.62811 14.0843 3.45461 14.0498 3.29275 13.9827C3.13088 13.9156 2.98383 13.8173 2.86 13.6933C2.73603 13.5695 2.63769 13.4224 2.57059 13.2605C2.50349 13.0987 2.46895 12.9252 2.46895 12.75C2.46895 12.5747 2.50349 12.4012 2.57059 12.2394C2.63769 12.0775 2.73603 11.9305 2.86 11.8066L2.9 11.7666C3.05369 11.6095 3.15679 11.4099 3.196 11.1937C3.23522 10.9774 3.20874 10.7544 3.12 10.5533C3.03549 10.3561 2.89517 10.1879 2.71631 10.0695C2.53745 9.95105 2.32786 9.88748 2.11333 9.88663H2C1.64638 9.88663 1.30724 9.74615 1.05719 9.4961C0.807142 9.24605 0.666667 8.90691 0.666667 8.55329C0.666667 8.19967 0.807142 7.86053 1.05719 7.61048C1.30724 7.36043 1.64638 7.21996 2 7.21996H2.06C2.28066 7.2148 2.49467 7.14337 2.6742 7.01497C2.85373 6.88656 2.99048 6.70712 3.06667 6.49996C3.15541 6.29888 3.18188 6.07583 3.14267 5.85957C3.10346 5.6433 3.00036 5.44375 2.84667 5.28663L2.80667 5.24663C2.6827 5.12279 2.58435 4.97574 2.51725 4.81388C2.45015 4.65202 2.41562 4.47851 2.41562 4.30329C2.41562 4.12807 2.45015 3.95457 2.51725 3.79271C2.58435 3.63084 2.6827 3.48379 2.80667 3.35996C2.9305 3.23599 3.07755 3.13765 3.23941 3.07055C3.40128 3.00345 3.57478 2.96891 3.75 2.96891C3.92522 2.96891 4.09872 3.00345 4.26059 3.07055C4.42245 3.13765 4.5695 3.23599 4.69333 3.35996L4.73333 3.39996C4.89045 3.55365 5.09001 3.65675 5.30627 3.69596C5.52254 3.73517 5.74559 3.7087 5.94667 3.61996H6C6.19718 3.53545 6.36534 3.39513 6.48379 3.21627C6.60225 3.03741 6.66581 2.82782 6.66667 2.61329V2.49996C6.66667 2.14634 6.80714 1.8072 7.05719 1.55715C7.30724 1.3071 7.64638 1.16663 8 1.16663C8.35362 1.16663 8.69276 1.3071 8.94281 1.55715C9.19286 1.8072 9.33333 2.14634 9.33333 2.49996V2.55996C9.33419 2.77448 9.39775 2.98408 9.5162 3.16294C9.63465 3.3418 9.80282 3.48212 10 3.56663C10.2011 3.65537 10.4241 3.68184 10.6404 3.64263C10.8567 3.60342 11.0562 3.50032 11.2133 3.34663L11.2533 3.30663C11.3772 3.18266 11.5242 3.08431 11.6861 3.01721C11.8479 2.95011 12.0214 2.91558 12.1967 2.91558C12.3719 2.91558 12.5454 2.95011 12.7073 3.01721C12.8691 3.08431 13.0162 3.18266 13.14 3.30663C13.264 3.43046 13.3623 3.57751 13.4294 3.73937C13.4965 3.90124 13.531 4.07474 13.531 4.24996C13.531 4.42518 13.4965 4.59868 13.4294 4.76055C13.3623 4.92241 13.264 5.06946 13.14 5.19329L13.1 5.23329C12.9463 5.39041 12.8432 5.58997 12.804 5.80623C12.7648 6.0225 12.7913 6.24555 12.88 6.44663V6.49996C12.9645 6.69714 13.1048 6.8653 13.2837 6.98375C13.4625 7.1022 13.6721 7.16577 13.8867 7.16663H14C14.3536 7.16663 14.6928 7.3071 14.9428 7.55715C15.1929 7.8072 15.3333 8.14634 15.3333 8.49996C15.3333 8.85358 15.1929 9.19272 14.9428 9.44277C14.6928 9.69282 14.3536 9.83329 14 9.83329H13.94C13.7255 9.83415 13.5159 9.89771 13.337 10.0162C13.1582 10.1346 13.0178 10.3028 12.9333 10.5V10.5Z"
                    stroke="#313131"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_129_1250">
                    <rect
                      width="16"
                      height="16"
                      fill="white"
                      transform="translate(0 0.5)"
                    />
                  </clipPath>
                </defs>
              </svg>
              <Link to={`/configuration/${store?.id}/`}>Configurações</Link>
            </S.ListItem>
            <S.ListItem
              isActive={false}
              style={{ cursor: 'pointer' }}
              role="button"
              onClick={() => logout()}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="17"
                viewBox="0 0 16 17"
                fill="none"
              >
                <path
                  d="M10.6667 11.8333L14 8.49996L10.6667 5.16663"
                  stroke="#313131"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M14 8.5H6"
                  stroke="#313131"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M6 14.5H3.33333C2.97971 14.5 2.64057 14.3595 2.39052 14.1095C2.14048 13.8594 2 13.5203 2 13.1667V3.83333C2 3.47971 2.14048 3.14057 2.39052 2.89052C2.64057 2.64048 2.97971 2.5 3.33333 2.5H6"
                  stroke="black"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              Sair
            </S.ListItem>
          </>
        )}
        {type === 'Admin' && (
          <>
            <S.ListItem isActive={pathname.includes('my-stores')}>
              <Link to={`/my-stores`}>Início</Link>
            </S.ListItem>
            <S.ListItem isActive={pathname.includes('admin/users')}>
              <Link to={`/admin/users`}>Usuários</Link>
            </S.ListItem>
            <S.ListItem isActive={pathname.includes('admin/stores')}>
              <Link to={`/admin/stores`}>Lojas</Link>
            </S.ListItem>
          </>
        )}
      </S.List>
    </S.MenuWrapper>
  )
}

export default Menu
